import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = logged out
  const [theme, setThemeState] = useState(localStorage.getItem("ff_theme") || "dark");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("ff_theme", theme);
  }, [theme]);

  const toggleTheme = () => setThemeState((t) => (t === "dark" ? "light" : "dark"));

  const refreshUser = useCallback(async () => {
    const t = localStorage.getItem("ff_token");
    if (!t) { setUser(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ff_token");
      setUser(null);
    }
  }, []);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  const login = (token, u) => {
    localStorage.setItem("ff_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("ff_token");
    setUser(null);
  };

  return (
    <AppContext.Provider value={{ user, setUser, theme, toggleTheme, login, logout, refreshUser }}>
      {children}
    </AppContext.Provider>
  );
}
